import { Fragment } from 'react'

import { IconBolt } from '@tabler/icons-react'

import { ActionCaptureBlock } from '../../types/blueprint'

import {
  BaseBlockConfig,
  Field,
  FORBIDDEN_IN_APP,
  TypeOption,
} from './_BaseBlockConfig'

class Config extends BaseBlockConfig<ActionCaptureBlock> {
  public override kind = 'capture' as const
  public override type = 'action' as const

  public override blockTypeConfig: TypeOption = {
    kind: this.kind,
    value: this.type,
    label: 'Actions',
    icon: IconBolt,
    forbiddenTemplateTypes: FORBIDDEN_IN_APP,
    helpText:
      'Toggle notes, actions, and attachments on or off without any field',
    hideName: true,
    hideDescription: true,
  }

  public override blockFieldsConfig: Field[] = []

  public override mapFormValueToBlock(
    block: ActionCaptureBlock
  ): ActionCaptureBlock {
    return block
  }

  public override renderBlock(): React.ReactNode {
    return <Fragment />
  }

  public override renderDisplayBlock(): React.ReactNode {
    return <Fragment />
  }
}

export const ActionsCaptureBlockConfig = new Config()
